
import { useEffect, useReducer } from "react";
import { linearValidationUpdateAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommonInfoCmpProps } from "../../types/commonTypes";
import { LinearContactInfo, LinearControparteInfo, completeLinearBaseValidationSchema, linear_controparteCtp_contactInfoItems } from "../../types/communication/communicationDataType";
import { genericStateReducer } from "../contact/genericStateReducer";
import { LSimpleText } from "../styled/Text.style";
import { selectCommunicationData } from "../../store";
import LinearCtpInfoCmp from "../contact/LinearCtpInfoCmp";
import { Vspace } from "../styled/Separators.style";

export const LinearAgreementStateAction = {
    UPDATE_STATE: '@@controparteInfo/UPDATE_STATE'
}

const LinearControparteCmp = (props: CommonInfoCmpProps<LinearControparteInfo>) => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { agreeValidationInfo, communication } = communicationData
    const dispatch = useAppDispatch();
    const { initValues, onChange } = props
    const [controparteState, controparteDispatch] = useReducer(genericStateReducer<LinearControparteInfo>(LinearAgreementStateAction), initValues);

    useEffect(() => {
        onChange && onChange(controparteState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controparteState])

    useEffect(() => {
        // init conducente info with assicurato info
        if (agreeValidationInfo) {
            const initCtpAssicInfo = controparteState.agree_contactInfo
            initCtpAssicInfo.name = initCtpAssicInfo.name || communication?.caiData?.data.vehicleB?.driver?.name || ''
            initCtpAssicInfo.surname = initCtpAssicInfo.surname || communication?.caiData?.data.vehicleB?.driver?.surname || ''
            initCtpAssicInfo.phoneNumber = initCtpAssicInfo.phoneNumber || communication?.caiData?.data.vehicleB?.driver?.telNumber || ''
            controparteDispatch({
                type: LinearAgreementStateAction.UPDATE_STATE, payload: {
                    agree_contactInfo: new LinearContactInfo(initCtpAssicInfo)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <LSimpleText>Inserisci il numero di cellulare della controparte e <strong>gli invieremo la richiesta di firma digitale del modulo</strong>.</LSimpleText>
            <Vspace qty={2}></Vspace>
            <LinearCtpInfoCmp
                initValues={controparteState?.agree_contactInfo}
                contactItems={linear_controparteCtp_contactInfoItems}
                onContactChange={(newContactInfo: Partial<LinearContactInfo>) =>
                    controparteDispatch({
                        type: LinearAgreementStateAction.UPDATE_STATE, payload: {
                            agree_contactInfo: new LinearContactInfo({
                                ...controparteState,
                                ...newContactInfo
                            })
                        }
                    })}
                validationSchema={completeLinearBaseValidationSchema}
                onValiddationStateChange={(formState: any) =>
                    dispatch(linearValidationUpdateAct({ agree_contactInfo: formState?.isValid }))
                }
            />
        </>
    )
}

export default LinearControparteCmp